


<template>
  <svg
    width="15"
    height="8"
    viewBox="0 0 15 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M1.32267 0H11.904C12.6345 0 13.2267 0.596954 13.2267 1.33333V2.13567C13.8163 2.35271 14.2222 2.80747 14.2222 3.33333V4.66667C14.2222 5.19253 13.8163 5.64729 13.2267 5.86433V6.66667C13.2267 7.40305 12.6345 8 11.904 8H1.32267C0.592178 8 0 7.40305 0 6.66667V1.33333C0 0.596954 0.592178 0 1.32267 0ZM5.54308 6.07007C5.51856 6.07007 5.49557 6.05934 5.47411 6.03788C5.45572 6.01949 5.44652 5.99804 5.44652 5.97352C5.44652 5.95819 5.44959 5.94287 5.45572 5.92754L7.00974 2.18501C7.04346 2.10838 7.10016 2.07007 7.17986 2.07007H7.61664C7.64423 2.07007 7.66721 2.0808 7.68561 2.10225C7.704 2.12064 7.71319 2.1421 7.71319 2.16662C7.71319 2.18195 7.71013 2.19727 7.704 2.2126L6.14078 5.95513C6.11013 6.03175 6.05342 6.07007 5.97066 6.07007H5.54308ZM2.45479 5.68386C2.42413 5.68386 2.39655 5.67313 2.37203 5.65168C2.35057 5.62716 2.33984 5.59957 2.33984 5.56892V2.58501C2.33984 2.55129 2.35057 2.52371 2.37203 2.50225C2.39348 2.47773 2.42107 2.46547 2.45479 2.46547H2.97433C3.04482 2.46547 3.09693 2.49459 3.13065 2.55283L4.21571 4.26777V2.58501C4.21571 2.55129 4.22643 2.52371 4.24789 2.50225C4.26935 2.47773 4.29693 2.46547 4.33065 2.46547H4.91456C4.94827 2.46547 4.97586 2.47773 4.99731 2.50225C5.01877 2.52371 5.0295 2.55129 5.0295 2.58501V5.56432C5.0295 5.59804 5.01877 5.62716 4.99731 5.65168C4.97586 5.67313 4.94827 5.68386 4.91456 5.68386H4.39502C4.32452 5.68386 4.27241 5.65474 4.23869 5.59651L3.15823 3.95053V5.56892C3.15823 5.60264 3.14597 5.63022 3.12145 5.65168C3.1 5.67313 3.07241 5.68386 3.03869 5.68386H2.45479ZM7.55134 5.65628C7.57279 5.67467 7.59578 5.68386 7.6203 5.68386H8.218C8.29157 5.68386 8.34367 5.65015 8.37433 5.58271L8.53984 5.13674H9.74444L9.90996 5.58271C9.94061 5.65015 9.99272 5.68386 10.0663 5.68386H10.664C10.6885 5.68386 10.71 5.67467 10.7283 5.65628C10.7498 5.63482 10.7605 5.61183 10.7605 5.58731C10.7605 5.56892 10.759 5.55513 10.7559 5.54593L9.68467 2.5988C9.65402 2.50992 9.59272 2.46547 9.50076 2.46547H8.78352C8.69157 2.46547 8.63026 2.50992 8.59961 2.5988L7.52835 5.54593C7.52528 5.55513 7.52375 5.56892 7.52375 5.58731C7.52375 5.61183 7.53295 5.63482 7.55134 5.65628ZM9.55134 4.44708H8.73295L9.14214 3.27467L9.55134 4.44708Z"
      :fill="fill"
    />
  </svg>
</template>

<script>
export default {
  name: 'BatteryNoDataIcon',
  props: {
    fill: {
      default: '#6B6E8D',
      type: String,
    },
  },
};
</script>
